/** Option lists and the string→union narrowing the Generator panel selects need. */

import type { TerrainKind } from "../../engine/terrain.ts";
import type { DeckMode } from "../../model/generator.ts";
import type { PlankFamily } from "../../model/solver.ts";

export const DECK_MODES: readonly { value: DeckMode; label: string }[] = [
  { value: "top", label: "Top lift" },
  { value: "all", label: "All lifts" },
  { value: "none", label: "None" },
];

export const PLANK_FAMILIES: readonly { value: PlankFamily; label: string }[] = [
  { value: "mix", label: "ALP 230 + 170" },
  { value: "230", label: "ALP 230" },
  { value: "170", label: "ALP 170" },
];

export const TERRAINS: readonly { value: TerrainKind; label: string }[] = [
  { value: "flat", label: "Flat" },
  { value: "slope", label: "Slope" },
  { value: "steps", label: "Steps" },
];

export function toDeckMode(value: string): DeckMode {
  if (value === "all") {
    return "all";
  }
  if (value === "none") {
    return "none";
  }

  return "top";
}

export function toPlankFamily(value: string): PlankFamily {
  if (value === "170") {
    return "170";
  }
  if (value === "230") {
    return "230";
  }

  return "mix";
}

export function toTerrain(value: string): TerrainKind {
  if (value === "slope") {
    return "slope";
  }
  if (value === "steps") {
    return "steps";
  }

  return "flat";
}
